import { SVGProps } from 'react';

export const IconInvitation = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path
        d='M5.02158 11.2451C5.02158 10.8642 5.47491 10.6501 5.78559 10.8843L11.5637 15.2402C11.8202 15.4335 12.1799 15.4335 12.4364 15.2402L18.2145 10.8843C18.5252 10.6501 18.9785 10.8642 18.9785 11.2451V17.8564C18.9785 18.488 18.4489 19 17.7957 19H6.20437C5.55113 19 5.02158 18.488 5.02158 17.8564V11.2451Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.776 9.31703C17.776 9.45843 17.7083 9.59187 17.5928 9.67852L12.4152 13.5609C12.1592 13.7528 11.8014 13.7528 11.5454 13.5609L6.36781 9.67852C6.25225 9.59187 6.18463 9.45843 6.18463 9.31703L6.18463 6.68209C6.18463 6.05048 6.71419 5.53845 7.36742 5.53845L16.5932 5.53845C17.2464 5.53845 17.776 6.05047 17.776 6.68209L17.776 9.31703ZM12.4403 7.68407C12.4403 7.35965 12.1773 7.09665 11.8529 7.09665C11.5285 7.09665 11.2655 7.35965 11.2655 7.68407V8.66309H10.2865C9.96205 8.66309 9.69905 8.92608 9.69905 9.2505C9.69905 9.57492 9.96205 9.83791 10.2865 9.83791H11.2655V10.8169C11.2655 11.1414 11.5285 11.4043 11.8529 11.4043C12.1773 11.4043 12.4403 11.1414 12.4403 10.8169V9.83791H13.4193C13.7438 9.83791 14.0067 9.57492 14.0067 9.2505C14.0067 8.92608 13.7438 8.66309 13.4193 8.66309H12.4403V7.68407Z'
        fill='currentColor'
      />
    </svg>
  );
};
